/**
 * comprala-chatbot-con-proxy.js
 * ==========================================================
 * Widget de chat para comprala.cl — versión segura post-incidente.
 *
 * Diferencia clave con la versión anterior (comprala-chatbot.js,
 * ahora desactivada): esta versión NO contiene ninguna API key.
 * Todas las llamadas van a WORKER_ENDPOINT (el Cloudflare Worker),
 * que es quien de verdad habla con Anthropic usando la key guardada
 * como secret en Cloudflare.
 * ==========================================================
 */

(function () {
  'use strict';

  const WORKER_ENDPOINT = 'https://comprala-chatbot.diegoengber.workers.dev';

  const MAX_HISTORY_MESSAGES = 10;

  let conversationHistory = [];
  let isWaitingForResponse = false;

  function buildWidget() {
    const container = document.createElement('div');
    container.id = 'cc-chatbot';
    container.innerHTML = `
      <button id="cc-chatbot-toggle" aria-label="Abrir chat" aria-expanded="false">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
        </svg>
      </button>
      <div id="cc-chatbot-window" hidden>
        <div id="cc-chatbot-header">
          <span>Asistente comprala.cl</span>
          <button id="cc-chatbot-close" aria-label="Cerrar chat">&times;</button>
        </div>
        <div id="cc-chatbot-messages" role="log" aria-live="polite"></div>
        <form id="cc-chatbot-form">
          <input id="cc-chatbot-input" type="text" placeholder="Escribe tu mensaje..." autocomplete="off" maxlength="500" />
          <button type="submit" id="cc-chatbot-send" aria-label="Enviar">Enviar</button>
        </form>
      </div>
    `;
    document.body.appendChild(container);
    injectStyles();
    attachEvents();
    appendMessage('assistant', '¡Hola! ¿En qué puedo ayudarte con tu compra en comprala.cl?');
  }

  function injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      #cc-chatbot { position: fixed; bottom: 20px; right: 20px; z-index: 999; font-family: inherit; }
      #cc-chatbot-toggle {
        width: 56px; height: 56px; border-radius: 50%; border: none;
        background: #1a1a1a; color: #fff; cursor: pointer;
        display: flex; align-items: center; justify-content: center;
        box-shadow: 0 4px 12px rgba(0,0,0,0.25);
      }
      #cc-chatbot-window {
        position: absolute; bottom: 70px; right: 0;
        width: 340px; max-width: calc(100vw - 40px); height: 460px;
        background: #fff; border-radius: 12px; box-shadow: 0 8px 30px rgba(0,0,0,0.2);
        display: flex; flex-direction: column; overflow: hidden;
      }
      #cc-chatbot-header {
        background: #1a1a1a; color: #fff; padding: 12px 16px;
        display: flex; justify-content: space-between; align-items: center;
        font-weight: 600; font-size: 14px;
      }
      #cc-chatbot-close { background: none; border: none; color: #fff; font-size: 20px; cursor: pointer; line-height: 1; }
      #cc-chatbot-messages { flex: 1; overflow-y: auto; padding: 12px; display: flex; flex-direction: column; gap: 8px; }
      .cc-msg { max-width: 80%; padding: 8px 12px; border-radius: 12px; font-size: 13px; line-height: 1.4; }
      .cc-msg--user { align-self: flex-end; background: #1a1a1a; color: #fff; border-bottom-right-radius: 2px; }
      .cc-msg--assistant { align-self: flex-start; background: #f0f0f0; color: #1a1a1a; border-bottom-left-radius: 2px; }
      .cc-msg--typing { align-self: flex-start; background: #f0f0f0; color: #999; font-style: italic; }
      #cc-chatbot-form { display: flex; border-top: 1px solid #eee; padding: 8px; gap: 8px; }
      #cc-chatbot-input { flex: 1; border: 1px solid #ddd; border-radius: 20px; padding: 8px 14px; font-size: 13px; }
      #cc-chatbot-send { background: #1a1a1a; color: #fff; border: none; border-radius: 20px; padding: 8px 16px; font-size: 13px; cursor: pointer; }
      #cc-chatbot-send:disabled { opacity: 0.5; cursor: default; }
    `;
    document.head.appendChild(style);
  }

  function attachEvents() {
    const toggle = document.getElementById('cc-chatbot-toggle');
    const closeBtn = document.getElementById('cc-chatbot-close');
    const win = document.getElementById('cc-chatbot-window');
    const form = document.getElementById('cc-chatbot-form');

    toggle.addEventListener('click', () => {
      const isHidden = win.hidden;
      win.hidden = !isHidden;
      toggle.setAttribute('aria-expanded', String(isHidden));
    });

    closeBtn.addEventListener('click', () => {
      win.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    });

    form.addEventListener('submit', handleSubmit);
  }

  async function handleSubmit(evt) {
    evt.preventDefault();
    if (isWaitingForResponse) return;

    const input = document.getElementById('cc-chatbot-input');
    const message = input.value.trim();
    if (!message) return;

    appendMessage('user', message);
    input.value = '';
    setSending(true);
    const typingEl = appendMessage('assistant', 'Escribiendo...', true);

    try {
      const response = await fetch(WORKER_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message,
          history: conversationHistory.slice(-MAX_HISTORY_MESSAGES),
        }),
      });

      const data = await response.json();
      typingEl.remove();

      if (!response.ok) {
        appendMessage('assistant', data.error || 'Ocurrió un error. Intenta de nuevo en unos minutos.');
        return;
      }

      appendMessage('assistant', data.reply);
      conversationHistory.push({ role: 'user', content: message });
      conversationHistory.push({ role: 'assistant', content: data.reply });
    } catch (err) {
      typingEl.remove();
      appendMessage('assistant', 'No pude conectarme. Revisa tu conexión e intenta de nuevo.');
    } finally {
      setSending(false);
    }
  }

  function setSending(sending) {
    isWaitingForResponse = sending;
    document.getElementById('cc-chatbot-send').disabled = sending;
  }

  function appendMessage(role, text, isTyping) {
    const messagesEl = document.getElementById('cc-chatbot-messages');
    const msgEl = document.createElement('div');
    msgEl.className = `cc-msg cc-msg--${role}${isTyping ? ' cc-msg--typing' : ''}`;
    msgEl.textContent = text;
    messagesEl.appendChild(msgEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return msgEl;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildWidget);
  } else {
    buildWidget();
  }
})();
